export const ITransactions = {
  account_transactions: [
    {
      id: 705,
      store_id: 56,
      subsidiary_ledger: 202,
      subledger: 1,
      journal_id: 197,
      amount: '13.150',
      second_amount: '0.000',
      exchange_rate: '0.000',
      created_at: '2024-01-08T05:28:21.821Z',
      affective_date: '2024-01-08T05:28:21.821Z',
    },
  ],
}

export const IAccountingJournal = {
  id: 159,
  description: 'this is des',
  ref: 'this is ref',
  kind: 0,
  link_id: 0,
  last_user_id: 15,
  transactions: ITransactions,
  created_at: '2024-01-02T11:05:40.060Z',
  updated_at: '2024-01-08T05:28:21.821Z',
  store_id: 56,
}

export const IAccountingJournalView = {
  id: 486,
  store_id: 56,
  subsidiary_ledger: 202,
  subledger: 12,
  journal_id: 130,
  amount: '-53.250',
  second_amount: '0.000',
  exchange_rate: '0.000',
  created_at: '2023-12-27T15:57:34.397Z',
  affective_date: '2023-12-27T15:57:34.397Z',
  description: 'this is des',
}
